// extracted by mini-css-extract-plugin
module.exports = {"is-invalid":"ClientMiscellaneousInvoiceItemEditModal_is-invalid__2koMH"};